<template>
  <div class="ai-search-loading">
    <div class="ai-search-loading__instance" />
  </div>
</template>

<script setup>
import lottie from 'lottie-web'
import data from './loading.json'

let anim

onMounted(() => {
  anim = lottie.loadAnimation({
    container: document.querySelector('.ai-search-loading__instance'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: data,
    assetsPath: '/loading/'
  })
})

onBeforeUnmount(() => {
  anim.destroy()
})
</script>

<style lang="less" scoped>
.ai-search-loading {
  position: relative;
  height: 120px;
  border-radius: 8px;
  border: 1px solid #EBF1F5;
  background-color: #F8F8F8;
  overflow: hidden;

  @media (min-width: 1024px) {
    height: 148px;
  }

  &__instance {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    height: 200px;

    @media (min-width: 1024px) {
      width: 660px;
      height: 330px;
    }

    &::before, &::after {
      z-index: 1;
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100px;

      @media (min-width: 1024px) {
        width: 140px;
      }
    }

    &::before {
      left: 0;
      background: linear-gradient(to right, #F8F8F8 60%, rgba(255, 255, 255, 0));
    }

    &::after {
      right: 0;
      background: linear-gradient(to left, #F8F8F8 60%, rgba(255, 255, 255, 0));
    }
  }
}
</style>
